import React, { useState } from 'react';
import { useViewlogies } from 'context';
import { hexToRGBA } from 'utils';
import StepIndicator from './StepIndicator';
import Step1 from './Step1';
import Step2 from './Step2';
import './registration.scss';

const RegistrationModal = ({ onComplete }) => {
    const {
        event: { color },
    } = useViewlogies();

    const [currentStep, setCurrentStep] = useState(1);

    const effectiveColor = color || '#253746';

    const backdropStyle = {
        backgroundColor: hexToRGBA(effectiveColor, 0.4),
    };

    return (
        <div className="registration-backdrop" style={backdropStyle}>
            <div className="registration-card">
                <StepIndicator step={currentStep} color={effectiveColor} />
                {currentStep === 1 ? (
                    <Step1 onNext={() => setCurrentStep(2)} color={effectiveColor} />
                ) : (
                    <Step2 onComplete={onComplete} color={effectiveColor} />
                )}
            </div>
        </div>
    );
};

export default RegistrationModal;
